export default __webpack_public_path__ + "static/media/hackathon-final.d5a46fae.gif";